import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../config/api';

const StatsSection = () => {
  const [institutes, setInstitutes] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/get_institutes.php`)
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          setInstitutes(res.data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const openPortal = (institute) => {
    setSelectedInstitute(institute);
    setIsModalOpen(true);
  };

  if (loading) return null;

  return (
    <section className="max-w-7xl mx-auto mb-20 px-4 relative z-20">
      <div className="flex flex-wrap justify-center gap-6">
        {institutes.map((inst) => (
          <div key={inst.id} className="flex-1 min-w-[240px] max-w-[300px] bg-white border border-orange-100 rounded-[2.5rem] p-6 text-center shadow-[0_10px_40px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgba(249,115,22,0.1)] hover:-translate-y-1 transition-all duration-300 group">
            <div className="bg-orange-50 w-24 h-24 mx-auto rounded-2xl flex items-center justify-center mb-6 shadow-inner border border-orange-100">
              {inst.logo_url ? (
                <img src={inst.logo_url} alt={inst.name} className="w-16 h-16 object-contain" />
              ) : (
                <div className="text-orange-500 font-bold text-xl">{inst.name}</div>
              )}
            </div>
            
            <h3 className="text-2xl font-black text-slate-800 tracking-tighter mb-1 uppercase italic">{inst.name}</h3>
            <p className="text-orange-500 font-bold text-xs tracking-widest mb-4 uppercase">{inst.location}</p>
            
            <p className="text-slate-400 text-[10px] leading-relaxed mb-6 font-medium">
              Academic year schedules and timetables
            </p>
            
            <button 
              onClick={() => openPortal(inst)}
              className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-black text-[10px] py-4 rounded-xl tracking-[0.2em] transition-all active:scale-95 shadow-[0_8px_20px_rgba(249,115,22,0.3)] flex items-center justify-center gap-2"
            >
              OPEN PORTAL 
              <span className="text-[8px]">›</span>
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedInstitute && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-[2rem] w-full max-w-2xl overflow-hidden shadow-2xl animate-slide-up border border-orange-50">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-orange-500 to-red-600 p-8 text-white relative">
              <h2 className="text-3xl font-black italic tracking-tighter uppercase mb-1">
                {selectedInstitute.name} TIMETABLE
              </h2>
              <p className="text-orange-100 font-medium italic opacity-80">{selectedInstitute.location}</p>
              
              <button 
                onClick={() => setIsModalOpen(false)}
                className="absolute top-6 right-6 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all"
              >
                <span className="text-2xl font-light">×</span>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-8 bg-slate-50/50">
              <div className="bg-white rounded-2xl border border-orange-100 overflow-hidden shadow-sm">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-orange-50/50 border-b border-orange-50 text-[10px] font-black tracking-widest text-orange-600 uppercase">
                      <th className="px-6 py-4">Session</th>
                      <th className="px-6 py-4">Class Segment</th>
                      <th className="px-6 py-4">Window</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-orange-50">
                    {selectedInstitute.schedules.length > 0 ? (
                      selectedInstitute.schedules.map((sched) => (
                        <tr key={sched.id} className="hover:bg-orange-50/20 transition-colors">
                          <td className="px-6 py-6 text-slate-400 font-mono text-xs">{sched.session_code}</td>
                          <td className="px-6 py-6">
                            <div className="font-black text-slate-800 text-sm tracking-tight">{sched.class_segment}</div>
                            <div className="text-[10px] font-black text-orange-500 tracking-wider uppercase mt-0.5">{sched.class_day}</div>
                          </td>
                          <td className="px-6 py-6 font-black text-slate-600 text-xs">{sched.time_window}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="px-6 py-12 text-center text-slate-400 italic">No schedules available for this portal yet.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <button 
                onClick={() => setIsModalOpen(false)}
                className="w-full mt-8 bg-slate-100 hover:bg-slate-200 text-slate-600 font-black italic text-xs py-4 rounded-2xl tracking-[0.2em] transition-all active:scale-[0.98]"
              >
                CLOSE PORTAL
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default StatsSection;
